import { useState } from 'react';
import { useTranslation } from '../../i18n/i18n';
import { Link } from 'react-router-dom';
import { ApiFeatureSheet } from '../../types';
import { ContentCard } from '../ContentCard/ContentCard';
import { Icon, chevron_down } from '../Icon/Icon';
import { formatValue } from './FeatureSheet';
import './FeatureSheetCard.css';

export function FeatureSheetCard({ data }: { data: ApiFeatureSheet }) {
	const { product: t, generic: tGeneric } = useTranslation();
	const featureGroup = data.featureGroups[0];
	const numOfGroups = data.featureGroups.length;
	const [showAllFeatures, setShowAllFeatures] = useState(false);
	const features = featureGroup.features;
	const shouldCollapse = features.length > 13;
	const displayedFeatures = shouldCollapse && !showAllFeatures ? features.slice(0, 10) : features;

	return (
		<ContentCard className={`feature-sheet-card ${numOfGroups > 1 ? 'not-mobile' : ''}`}>
			<h2>{t.productSpecifications}</h2>
			<div className="feature-group-wrapper">
				<div className="feature-group">
					{displayedFeatures.map((feature, i) => (
						<div className="feature-row" key={feature.name + i}>
							<p>{feature.name}</p>
							<p>{formatValue(feature.value)}</p>
						</div>
					))}
				</div>
				{shouldCollapse && (
					<button
						type="button"
						className="feature-sheet-link feature-sheet-toggle"
						onClick={() => setShowAllFeatures((prev) => !prev)}
						aria-expanded={showAllFeatures}
					>
						<span>{showAllFeatures ? tGeneric.showLess : tGeneric.showMore}</span>
						<Icon
							shape={chevron_down}
							size={18}
							className={`feature-sheet-icon ${showAllFeatures ? 'expanded' : ''}`}
						/>
					</button>
				)}
			</div>
			{numOfGroups > 1 && (
				<Link to="#product-specifications" className="feature-sheet-link">
					{t.seeAllSpecs} <span style={{ marginLeft: '5px' }}>→</span>
				</Link>
			)}
		</ContentCard>
	);
}
